<template>
  <div class="version-control-comp draft">
    <div class="header">
      <span>版本记录（{{list.length}}/{{max}}）</span>
      <span
        class="close"
        @click="closeVersionControl"
      ></span>
    </div>
    <div
      class="btn"
      @click="clickToCreate"
      :class="{disabled: isCreating}"
    >创建版本记录</div>
    <div class="content">
      <ul
        class="list"
        v-if="list.length"
      >
        <li
          class="item"
          v-for="(item, i) in list"
          :key="i"
        >
          <my-item
            :item="item"
            :index="i"
            @openEditing="openEditing"
            @inputBlur="inputBlur"
            @revert="revert"
            @remove="remove"
            @preview="preview"
          ></my-item>
        </li>
      </ul>
      <div
        class="empty-msg"
        v-if="!list.length"
      >
        <historyEmpty></historyEmpty>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import myItem from '@/components/versionControl/item';
import historyEmpty from '@/components/widgets/historyEmpty';

export default {
  components: {
    myItem,
    historyEmpty
  },
  data () {
    return {
      max: 20,
      list: [

      ],
      isCreating: false
    };
  },
  computed: {
    ...mapGetters([
      'cooperationType',
      'historyVersionList',
      'WorksId',
      'UserMsg',
      'UserLevel',
      'UserLevelType'
    ]),
    ...mapGetters({

    }),
    isEditing () {
      return this.list.some(item => item.editing);
    }
  },
  created () {
    this.$store.commit('draftVersion/setDraftId', this.WorksId);
    this.updateList();
    $('body').on('keydown', () => {
      let index = this.list.findIndex(item => item.editing);
      $(this.$el).find('textarea').eq(index).focus();
    });

    this.$bus.on('versionRemove.confirm', this.confirmRemove);
    this.$bus.on('versionRemove.close', this.cancelRemove);

    this.$bus.on('versionRevert.confirm', this.confirmRevert);
    this.$bus.on('versionRevert.close', this.cancelRevert);
  },
  beforeDestroy () {
    this.$bus.off('versionRemove.confirm');
    this.$bus.off('versionRemove.close');
    this.$bus.off('versionRevert.confirm');
    this.$bus.off('versionRevert.close');
  },
  methods: {
    ...mapActions({
      fetchDraftVersions: 'draftVersion/fetchList',
      createDraftVersion: 'draftVersion/createVersion',
      removeDraftVersion: 'draftVersion/removeVersion',
      revertDraftVersion: 'draftVersion/revertVersion',
      updateVersionComment: 'draftVersion/updateComment'
    }),
    ...mapActions([
      'refreshHistotyVersionList',
      'createNewHistotyVersion',
      'reloadHistotyVersion',
      'deleteHistotyVersion',
      'editHistotyVersion'
    ]),
    closeVersionControl () {
      this.$store.commit('versionControl/set_VersionControlShow', false);
    },
    updateList () {
      let draftId = this.WorksId;
      return this.fetchDraftVersions({ draftId })
        .then(data => {
          this.updateList_(data);

          return data;
        })
    },
    updateList_ (data) {
      const list = [];
      data.forEach(item => {
        list.push({
          editing: false,
          time: new Date(item.date),
          name: this.UserMsg.nickname || '',
          comment: item.comment || '',
          figure: this.$handleAssetsUrl(this.UserMsg.headImgUrl || ''),
          data: item
        });
      });
      this.list = list;
    },
    clickToCreate () {
      if (this.UserLevel === 0 && this.UserLevelType === 0) {
        this.$modal.show("vipDialog", {
          msg: "升级会员，解锁版本记录功能，版本回溯可无忧",
          target: "vipsolo",
          type: "solo",
          soloTip: '创建版本记录(20条)'
        });
        return;
      }
      if (this.list && this.list.length >= 20) {
        this.$message({
          showClose: true,
          message: "最多只能保留20个版本记录",
          type: "error"
        });
      }
      if (this.isCreating) {
        return;
      }
      this.isCreating = true;

      let obj = {
        editing: true,
        comment: ''
      };
      this.list.forEach(item => {
        if (item.editing) {
          this.$set(item, 'editing', false);
        }
      });
      this.list = [obj, ...this.list];
    },
    openEditing ({ index } = {}) {
      this.list.forEach((item, i) => {
        if (index === i) {
          this.$set(item, 'editing', true);
        }
        else if (item.editing) {
          this.$set(item, 'editing', false);
        }
      });
    },
    async inputBlur ({ index, value, itemId } = {}) {
      if (this.list.some(item => item.data && (item.data || {}).id === itemId)) {
        // this.editHistotyVersion({ id: itemId, description: value });
        await this.updateVersionComment({
          versionId: itemId,
          comment: value
        });
        await this.updateList();
      } else {
        this.$set(this.list[0], 'comment', '正在创建...');
        this.$bus.once('saveWorks.completed', async () => {
          let list = await this.createDraftVersion({
            comment: value
          });
          this.updateList_(list);
          this.isCreating = false;
        });
        this.$bus.emit("save", {});
      }
      this.$set(this.list[index], 'editing', false);
    },
    revert ({ item } = {}) {
      this.$modal.show('versionRevert');
      this.revertingId = item.data.id;
    },
    async confirmRevert ({
      checked
    } = {}) {
      let rev = async () => {
        await this.revertDraftVersion({ versionId: this.revertingId });
        this.$modal.hide('versionRevert');
        this.revertingId = '';
        this.updateList();
        window.location.reload();
      }
      if (checked) {
        this.$bus.once('saveWorks.completed', rev);
        this.$bus.emit("save", {});
      } else {
        rev();
      }
    },
    cancelRevert () {
      this.revertingId = '';
    },
    remove ({ item } = {}) {
      // this.$modal.show('versionRemove');
      // this.removingId = item.data.id;
      this.$modal.show("MessageDialog", {
        // title: "登录状态异常。",
        content:
          "确定删除选中版本吗？删除之后将不可恢复，但不会对当前项目数据造成任何影响。",
        btns: ['Ok', 'Cancel', 'Close'],
        resultHandler: type => {
          if (type === 'Ok') {
            this.removingId = item.data.id;
            this.confirmRemove();
          } else {
            this.cancelRemove();
          }
        }
      });
    },
    async confirmRemove () {
      let versionId = await this.removeDraftVersion({ versionId: this.removingId });
      this.$modal.hide('versionRemove');
      this.removingId = '';
      this.updateList();
      // if (versionId) {
      //   let list = this.list.filter(item => item.id !== versionId) || [];
      //   this.list = list;
      // }
    },
    cancelRemove () {
      this.removingId = '';
    },
    preview ({ item } = {}) {
      let itemId = item.data.id;
      let link = document.createElement('a');
      link.href = window.location.origin + `/draftpreview/index.html?id=${itemId}&draftversion=1`;
      link.target = "_blank";
      link.click();
    }
  },
};
</script>

<style lang="scss" scoped>
.version-control-comp {
  display: flex;
  flex-direction: column;
  padding: 12px 10px;
  height: 100%;
  z-index: 1;
  & > .header {
    flex-shrink: 0;
  }
  & > .content {
    flex-grow: 1;
    margin-top: 20px;
    overflow: auto;
    width: calc(100% + 36px);
    background: linear-gradient(white 30%, hsla(0, 0%, 100%, 0)),
      linear-gradient(hsla(0, 0%, 100%, 0) 10px, white 70%) bottom,
      radial-gradient(at top, rgba(0, 0, 0, 0.2), transparent 70%),
      radial-gradient(at bottom, rgba(0, 0, 0, 0.2), transparent 70%) bottom;
    background-repeat: no-repeat;
    background-size: 100% 20px, 100% 20px, 100% 10px, 100% 10px;
    background-attachment: local, local, scroll, scroll;

    & .empty-msg {
      width: 226px;
      height: 100%;
      display: flex !important;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding-top: 50px;
      line-height: 1.5;
    }
  }
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.close {
  width: 12px;
  height: 12px;
  cursor: pointer;
  background-image: url(../../../static/svg/materialPane/closePane.svg);
}
.btn {
  width: 226px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  margin: auto;
  background-color: #5778fb;
  color: #fff;
  cursor: pointer;
  &.disabled {
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/versionControl/DraftVersionControl.vue